import React from 'react';

const wrappedComponent = (props) => (WrappedComponent) => () => (
  <WrappedComponent />
);

export default wrappedComponent;
